import gql from "graphql-tag";

export const SCHEDULE = gql`
	mutation ($mailSetId: UUID!, $scheduledDateTime: DateTime!) {
		schedule(
			input: { mailSetId: $mailSetId, scheduledDateTime: $scheduledDateTime }
		) {
			success
			errors
		}
	}
`;
